var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<p class=\"input-group\"> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"d.M.yyyy\" ng-model=\"ngModel\" ng-readonly=\"$ctrl.ngReadonly\" ng-change=\"$ctrl.ngChange\" is-open=\"open\" datepicker-options=\"$ctrl.dateOptions\" ng-required=\"{{$ctrl.required}}\" close-text=\"{{ 'common.close' | i18next }}\" clear-text=\"{{ 'common.clear' | i18next }}\" current-text=\"{{ 'common.today' | i18next }}\"/>\n<span class=\"input-group-btn\"> <button type=\"button\" ng-disabled=\"$ctrl.ngReadonly\" class=\"btn btn-default\" ng-click=\"open = true\"> <i class=\"glyphicon glyphicon-calendar\"></i> </button> </span> </p>";
var id1="dateInput.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/core/dateInput.html
// module id = 41
// module chunks = 0 2